<template>
  <section class="value-chain module">
    <div class="container">
      <div class="hex-wrapper">
        <div
          class="hex-container"
          :class="`pos-${position}`">
          <div
            v-for="(item, index) in data.value_chain_hexes"
            :key="index"
            class="hex">
            <div
              class="hex-btn"
              @click="openModal(index, data.value_chain_hexes)"></div>
            <div class="hex-content">
              <div
                class="title font-larger"
                v-html="item.value_chain_hex_headline"></div>
            </div>
          </div>
        </div>
        <div class="arrows">
          <button
            class="arrow prev"
            :disabled="position == 1"
            @click="prev"></button>
          <button
            class="arrow next"
            :disabled="position == data.value_chain_hexes.length"
            @click="next"></button>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
/* #META
   {
    "NAME": "ValueChainComponent",
    "CLASSNAME": "value-chain",
    "URL": "http://insitro.local/test/"
   }
  #ENDMETA */
import { ref, inject } from 'vue'

defineProps(['data'])

const valueChainModal = inject('valueChainModal')

const position = ref(1)

const prev = () => {
  position.value = position.value - 1
}

const next = () => {
  position.value = position.value + 1
}

const openModal = (index, hexData) => {
  valueChainModal.value.open = true
  valueChainModal.value.index = index
  valueChainModal.value.data = hexData
}
</script>

<style lang="scss">
.value-chain {
  overflow: hidden;

  .container {
    @include mobile {
      width: 299px;
    }
  }

  .hex-wrapper {
    position: relative;
    padding: 60px 0 0;

    @include mobile {
      padding: 60px 0;
    }

    .arrows {
      display: none;
      position: absolute;
      bottom: 0;
      left: 50%;
      z-index: 1;
      align-items: center;
      transform: translateX(-50%);

      @include mobile {
        display: flex;
      }

      .arrow {
        cursor: pointer;
        width: 60px;
        height: 60px;
        padding: 0;
        opacity: 1;
        background-image: url('@/assets/img/icon-arrow.svg');
        background-repeat: no-repeat;
        background-size: contain !important;
        background-color: transparent !important;
        border: none !important;
        @include transition;

        &.prev {
          transform: rotate(180deg);
        }

        &:disabled {
          cursor: default;
          pointer-events: none;
          opacity: 0.7;
        }
      }
    }
  }

  .hex-container {
    position: relative;
    display: flex;
    justify-content: space-between;
    transform: translateX(0%);
    left: 0;
    @include transition;

    &.pos-1 {
      transform: translateX(0%);
      left: 0;
    }

    &.pos-2 {
      transform: translateX(-50%);
      left: 50%;
    }

    &.pos-3 {
      transform: translateX(-100%);
      left: 100%;
    }

    @include mobile {
      width: 1130px;
    }

    &:after {
      content: '';
      position: absolute;
      top: calc(50% - 40px);
      left: 50%;
      display: block;
      width: 76%;
      height: 30px;
      transform: translate(-50%, -50%);
      background-image: url('@/assets/img/line-long.svg');
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
    }

    .hex {
      position: relative;
      width: 26.5%;
      height: 0;
      padding-bottom: 30.5%;
      background-image: url('@/assets/img/hex-outline-semitransparent.svg');
      background-repeat: no-repeat;
      background-size: contain;

      @include mobile {
        width: 299px;
        height: 344px;
        padding: 0;
      }

      &:last-child {
        &:after {
          content: none;
        }
      }

      &:after {
        content: '';
        position: absolute;
        top: calc(50% + 7px);
        right: -25px;
        display: block;
        width: 64px;
        height: 16px;
        transform: translate(100%, -50%);
        background-image: url('@/assets/img/arrow-right-long.svg');
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;

        @include tablet-landscape(1) {
          right: -10px;
          width: 50px;
          height: 12px;
        }

        @include mobile {
          right: -25px;
          width: 64px;
          height: 16px;
        }
      }

      .hex-btn {
        cursor: pointer;
        position: absolute;
        top: 0;
        left: 50%;
        width: 94px;
        height: 94px;
        transform: translate(-53%, -50%) rotate(0deg) scale(1);
        background-image: url('@/assets/img/icon-plus.svg');
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        z-index: 1;
        @include transition;

        &:hover {
          transform: translate(-53%, -50%) rotate(90deg) scale(1.1);
        }
      }

      .hex-content {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
      }

      .title {
        width: 70%;
        margin: 40px auto 0;
        text-align: center;
      }
    }
  }
}
</style>
